<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('问题反馈', '用户、工号、电话、反馈内容、反馈图片、反馈时间、是否回复、回复内容、回复时间')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
            <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.is_reply===1"
                       @click.stop="handleReply(scope.row,scope.index)">回复
            </el-button>
        </template>

        <template slot-scope="scope" slot="is_reply">
            <span v-if="scope.row.is_reply===1" style="color: crimson">未回复</span>
            <span v-if="scope.row.is_reply===2" style="color: green">已回复</span>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增通知', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '反馈内容',
              overHidden: true,
              prop: 'content',
              editDisplay: false,
              span: 24,
              align: 'left',
            }, {
              label: '用户',
              prop: 'user-username',
              editDisplay: false,
              span: 24
            }, {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            }, {
              label: '图片',
              prop: 'filepaths',
              editDisplay: false,
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            }, {
              label: '是否回复',
              prop: 'is_reply',
              type: 'select',
              editDisplay: false,
              search: true,
              slot: true,
              dicUrl: this.getDic('is_reply')
            }, {
              label: '回复',
              prop: 'reply',
              span: 24,
              rules: [{
                required: true, message: '回复不能为空', trigger: 'blur'
              }],
              overHidden: true,
            }, {
              label: '回复时间',
              prop: 'reply_time',
              editDisplay: false
            }
          ]
        }
      }
    },
    methods: {
      // 回复
      handleReply(row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    }
  }
</script>
